// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

export const SortTypesList = styled.ul`
  background-color: ${buildColor("white", "100")};
  display: flex;
  flex-direction: column;
  list-style: none;
`;

export const SortTypeContainer = styled.li`
  height: 48px;

  &:hover :active {
    background-color: ${buildColor("grey", "100")};
  }

  &:focus,
  &:hover {
    background-color: ${buildColor("white", "100")};
  }

  &:not(:last-child) > div {
    border-bottom: 1px solid ${buildColor("grey", "300")};
  }
`;

export const SortTypeWrapper = styled.div`
  height: 100%;
  margin-left: 16px;
  padding-right: 12px;
  line-height: 125%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SortType = styled.span`
  ${({ isActive }) =>
    isActive
      ? css`
          font-family: ${fontBold};
        `
      : css`
          font-family: ${fontNormal};
          font-weight: normal;
        `};
  font-size: 14px;
  color: ${buildColor("blue", "500")};
  text-transform: capitalize;
`;

export const SortOrder = styled.span`
  font-size: 14px;
  font-family: ${fontNormal};
`;
